import { normalize } from 'normalizr';

import { environmentSchema } from './schemas';

export const normalizeProject = (projectJson: {}) => normalize(projectJson, { environments: [environmentSchema] });
export const normalizeEnvironments = (environmentJson: {}) =>
  normalize(environmentJson, { environments: [environmentSchema] });
